import {extend, override} from 'flarum/common/extend';
import app from 'flarum/forum/app';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import FieldList from './fields/FieldList';
import Uploader from './utils/Uploader';
import isHorizontalLayout from './utils/isHorizontalLayout';
import parseValidationError from './utils/parseValidationError';

export default function () {
    extend(SignUpModal.prototype, 'oninit', function (this: SignUpModal) {
        const forms = app.forum.formulaireSignUpForms() || [];

        this.formulaire = {};
        this.formulaireValidationErrors = {};

        forms.forEach(form => {
            this.formulaire[form.id()!] = {
                value: {},
                uploader: new Uploader(form),
            };
        });
    });

    extend(SignUpModal.prototype, 'fields', function (this: SignUpModal, items) {
        const forms = app.forum.formulaireSignUpForms() || [];

        forms.forEach(form => {
            const state = this.formulaire[form.id()!];

            const list = new FieldList({
                configs: form.template()!,
                submission: state.value,
                uploader: state.uploader,
                disabled: this.loading || state.uploader.uploading,
                validationErrors: (this.formulaireValidationErrors.formulaireForms || {})[form.id()!],
            });

            items.add('formulaire-' + form.seoId(), m('.FormulaireSignUpForm', {
                className: isHorizontalLayout('SignUp') ? 'Formulaire-horizontal-layout' : '',
            }, list.listView()));
        });
    });

    extend(SignUpModal.prototype, 'submitData', function (this: SignUpModal, data: any) {
        const forms = app.forum.formulaireSignUpForms() || [];

        forms.forEach(form => {
            // We can't use a relationships object because the /register endpoint doesn't follow JSON:API
            if (!data.formulaireForms) {
                data.formulaireForms = [];
            }

            data.formulaireForms.push({
                id: form.id(),
                attributes: {
                    data: this.formulaire[form.id()!].value,
                },
            });
        });
    });

    // Use override so our code happens before the modal's redraw, so we don't have to redraw twice
    // Also for some reason the code doesn't seem to be called at all when using extend()
    override(SignUpModal.prototype, 'onerror', function (original, error) {
        if (error.status === 422 && error.response?.errors) {
            this.formulaireValidationErrors = parseValidationError(error);
        }

        return original(error);
    });
}
